import { useState, useEffect } from 'react';
import { Navigation } from './Navigation';

export function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section id="hero" className="relative min-h-screen overflow-hidden bg-black">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/4ba18deeba7ddce54aa09cc5bd3ecdf6.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80"></div>
      </div>

      <Navigation scrolled={scrolled} />

      <div className="relative z-10 container mx-auto px-6 h-screen flex items-center">
        <div className="w-full text-center pt-20 sm:pt-0">
          <div className="text-white space-y-8 max-w-4xl mx-auto">
            <div className="space-y-6">
              <p className="text-lg tracking-[0.3em] text-pink-400 font-medium">
                ARTIST × FAN = HAPPINESS
              </p>
              <h1 className="text-4xl sm:text-6xl lg:text-8xl font-black leading-tight whitespace-nowrap" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                <span className="inline-block bg-gradient-to-r from-pink-400 via-purple-400 to-blue-400 bg-clip-text text-transparent">夢を、一緒に</span>
              </h1>
              <p className="text-xl lg:text-2xl font-light tracking-wider text-gray-300">
                <span className="block sm:inline text-xs sm:text-lg">Empowering Artists.</span>
                <span className="hidden sm:inline">&nbsp;&nbsp;</span>
                <span className="block sm:inline text-xs sm:text-lg">Elevating Fans.</span>
                <span className="hidden sm:inline">&nbsp;&nbsp;</span>
                <span className="block sm:inline text-xs sm:text-lg">Creating Dreams Together.</span>
              </p>
            </div>

            <div className="max-w-2xl mx-auto space-y-4">
              <p className="text-xs sm:text-lg text-gray-300 leading-relaxed">
                <span className="block sm:inline">アーティストの可能性を最大化し、</span>
                <span className="block sm:inline">ファンと共に夢を現実へ変える。</span>
              </p>
              <p className="text-xs sm:text-base text-gray-400">
                <span className="block sm:inline">アーティストとファン、</span>
                <span className="block sm:inline">両方が幸せになるエンタメ体験を。</span>
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-8 justify-center">
              <a
                href="#about"
                className="inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 text-white rounded-full font-medium hover:shadow-lg hover:shadow-pink-500/30 transition-all whitespace-nowrap cursor-pointer group"
              >
                私たちの理念
                <i className="ri-arrow-right-up-line ml-2 text-xl group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"></i>
              </a>
              <a
                href="#contact"
                className="inline-flex items-center justify-center px-8 py-4 bg-transparent border-2 border-white/30 text-white rounded-full font-medium hover:border-pink-400 hover:text-pink-400 transition-all whitespace-nowrap cursor-pointer group"
              >
                お問い合わせ
                <i className="ri-mail-line ml-2 text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-pink-400"></i>
      </div>
    </section>
  );
}
